import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { isInternalUrl } from '../../../utils';
import CustomExternalAnchor from '../customExternalAnchor';
import { TRoutableSiteCoreLinkField } from '../../../types/types';

/** React component that turns Sitecore link values that start are internal into react-router route links */
const RoutableSitecoreLink: FC<TRoutableSiteCoreLinkField> = (props) => {
  const { field, editable = true, children } = props;
  const hasValidHref = field?.value?.href;
  const isEditing = editable && field?.editable;

  // only want to apply the routing link if not editing (if editing, need to render editable link value)
  if (hasValidHref && !isEditing) {
    const value = field.value;

    // determine if a link is a route or not. This logic may not be appropriate for all usages.
    if (isInternalUrl(value.href)) {
      return (
        <RouterLink
          to={value.href}
          title={value.title}
          target={value?.target}
          className={props.className ?? value.class}
          onClick={props.onClick}
        >
          {children || value.text || value.href}
        </RouterLink>
      );
    }
  }

  return <CustomExternalAnchor {...props} />;
};

export default RoutableSitecoreLink;
